import { useState, useEffect } from 'react';
import { checkAdminRole } from '../lib/adminApi';

/**
 * Hook to check if the current user is an admin.
 * Returns { isAdmin, isSuperAdmin, loading, error, email, role }
 */
export function useAdminAuth() {
  const [state, setState] = useState({
    isAdmin: false,
    isSuperAdmin: false,
    loading: true,
    error: null,
    email: null,
    role: null,
  });

  useEffect(() => {
    let mounted = true;

    async function checkRole() {
      try {
        const data = await checkAdminRole();
        if (mounted) {
          setState({
            isAdmin: data.isAdmin === true,
            isSuperAdmin: data.isSuperAdmin === true,
            loading: false,
            error: null,
            email: data.email,
            role: data.role,
          });
        }
      } catch (err) {
        if (mounted) {
          setState({
            isAdmin: false,
            isSuperAdmin: false,
            loading: false,
            error: err.message || 'Failed to check admin status',
            email: null,
            role: null,
          });
        }
      }
    }

    checkRole();

    return () => {
      mounted = false;
    };
  }, []);

  return state;
}

export default useAdminAuth;
